import { Component, OnInit, ViewChild, HostListener, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router, NavigationEnd, Event, NavigationStart } from '@angular/router';
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { rotate } from '../theme/utils/app-animation';
import { MenuService } from '../theme/components/menu/menu.service';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { map, catchError } from "rxjs/operators";
import { fromEvent, interval, merge, Observable, Observer, Subscription, throwError } from 'rxjs';
import { AppOAuthStore } from '../models/AppOAuthSotarge';
import { Menu } from '../theme/components/menu/menu.model';
import { verticalMenuItems } from '../theme/components/menu/menu';
import { IsOnlineService } from '../services/IsOnline.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  animations: [ rotate ],
  providers: [ MenuService ]
})
export class PagesComponent implements OnInit { 
  @ViewChild('sidenav') sidenav: any;  
  @ViewChild('options') opts: any;
  @ViewChild('backToTop') backToTop:any;  
  @ViewChild('topTB') topTB: any;
  @ViewChild('isOnlineRow') isOnlineRow: ElementRef;
  @ViewChildren(PerfectScrollbarDirective) pss: QueryList<PerfectScrollbarDirective>;
  private subs = new Subscription();
  public optionsPsConfig: PerfectScrollbarConfigInterface = {};
  public settings:Settings;
  public showSidenav:boolean = false;
  public showInfoContent:boolean = false;
  public toggleSearchBar:boolean = false;
  private defaultMenu:string; //declared for return default menu when window resized 
  public menus = ['vertical', 'horizontal'];
  public menuOption:string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption:string;
  public menuss: Array<Menu> = verticalMenuItems;
  private connectSvc;
  public online: boolean = true;
  public internetAccess: boolean = true;
  public isOnlineClass: string = "online";
  public intervalRequest = interval(30000);
  private compRef: any;
  public usuario: string;
  constructor(public appSettings:AppSettings, public router:Router, private myStorage: AppOAuthStore,
              private menuService: MenuService,  httpConn: httpConnect, private isOnlineServ: IsOnlineService){        
    this.settings = this.appSettings.settings;
    this.connectSvc = httpConn;
    this.usuario = this.myStorage.getItem('nombre_personal');
  }
  
  onActivate(componentRef){
    if (componentRef.componentName){
      switch (componentRef.componentName) {
        case 'FrapDigitalComponent':
          this.compRef = componentRef;
        default: /* 2021-10-02 (aaangeles) */
          this.compRef = componentRef;      
      }
    }
  }

  onDeactivate(componentRef){
    this.compRef = undefined;
  }

  ngOnInit() {
    this.optionsPsConfig.wheelPropagation = false;
    if(window.innerWidth <= 960){
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }
    this.menuOption = this.settings.menu; 
    this.menuTypeOption = this.settings.menuType; 
    this.defaultMenu = this.settings.menu;

     //Escucha los cambios en la navegación, verifica si tiene permisos para ingresar a la pantalla que se intenta acceder
    //y redirige a la pantalla de Dashboard en caso de que no se tengan permisos 
    this.router.events.subscribe((event : Event) =>{
      if(event instanceof NavigationStart){
        //this.settings.loadingSpinner = true;
        if(!(event.url.replace('/', '') == "dashboard") && !(event.url.replace('/', '') == 'login') && !(event.url.replace('/','') == '')){
          // this.getPermisoVista(this.menuss.find(m => m.routerLink == event.url).id_menu).subscribe(
          //   res => {
               this.toggleSidenav();
          //   }, err => {
          //     this.myStorage.clear();
          //     this.router.navigate(['/']);
          //   }
          // );
        }
      }
    })
    this.subs.add(this.isOnlineServ.createOnline$().subscribe((isOnline: boolean) =>  {
      this.online = isOnline; 
      if(isOnline) {
        this.intervalRequest.subscribe(() => { 
          this.isOnlineServ.makeRequest()
          .subscribe(res => {
            if (res) {
              this.internetAccess = true;
              setTimeout(() => {
                this.isOnlineClass = 'online'
              }, 2000)
            }
            else {
              this.internetAccess = false;
              this.isOnlineClass = 'offline'
            }
          }, error => {
            this.internetAccess = false;
            this.isOnlineClass = 'offline'
          })
        })
      }
      else { 
        this.internetAccess = false;
        this.isOnlineClass = "offline"
      }
    }));
  }

  ngAfterViewInit(){
    setTimeout(() => { this.settings.loadingSpinner = false }, 300); 
    this.backToTop.nativeElement.style.display = 'none'; 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      } 
      if(window.innerWidth <= 960){
        this.sidenav.close(); 
      }                
    });
    // if(this.settings.menu == "vertical")
    //   this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems()); 
  }

  ngOnDestroy(){
    this.subs.unsubscribe();
  }      
  public getPermisoVista(view : string){
    let permiso = JSON.parse(this.myStorage.getItem("permisos")).find(p => (p.desc_modulo + ' / ' + p.desc_permiso) == view);
    let params = {
        id_permiso : permiso.id_permiso, 
        id_perfil : this.myStorage.getItem('id_perfil')
    }
    
    return this.connectSvc.postAPI('Seguridad', 'GetPermisoVista', params)
    .pipe(
        map((data: any) =>{
            if(data.response.length == 0){                
                this.myStorage.clear();
                this.router.navigate(['/login']);                     
            } else if (view == 'dashboard'){
                this.router.navigate(['/dashboard']);
            }
        })
        ,catchError(err =>{
            return throwError(err.error);
        })
    ) 
  }

  public toggleSidenav(){
    if(this.settings.menuType == 'compact') {
      this.settings.menuType = 'mini';
      this.menuService.closeAllSubMenus();
    }
    this.sidenav.toggle();
   // this.compRef.divActionBtns.nativeElement.style.marginLeft="250px";
  }

  public chooseMenu(){
    this.settings.menu = this.menuOption; 
    this.defaultMenu = this.menuOption;
    if(this.menuOption == 'horizontal'){
      this.settings.fixedSidenav = false;
    }
    this.router.navigate(['/']); 
  }

  public chooseMenuType(){
    this.settings.menuType = this.menuTypeOption;
  }

  public changeTheme(theme){
    this.settings.theme = theme;       
  }
  
  public closeInfoContent(showInfoContent){
    this.showInfoContent = !showInfoContent;
  }

  @HostListener('window:resize')
  public onWindowResize():void {
    if(window.innerWidth <= 960){
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical'
    }
    else{
      (this.defaultMenu == 'horizontal') ? this.settings.menu = 'horizontal' : this.settings.menu = 'vertical'
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  public onPsScrollY(event){   
    if (!!this.compRef && this.compRef.componentName){
      if (this.compRef.componentName == 'frapDigitalComponent') {
        if(window.innerWidth <= 960) {
          if (event.target.scrollTop > 200) { 
            this.topTB.nativeElement.parentElement.style.display = 'none';
            this.isOnlineRow.nativeElement.style.top = "0px";
          }
          else { 
            this.topTB.nativeElement.parentElement.style.display = 'block';
            this.isOnlineRow.nativeElement.style.top = "56px";
          }
        }
      }
    }
    (event.target.scrollTop > 300) ? this.backToTop.nativeElement.style.display = 'flex' : this.backToTop.nativeElement.style.display = 'none';
  }

  public scrollToTop() {
    this.pss.forEach(ps => {
      if(ps.elementRef.nativeElement.id == 'main'){
        ps.scrollToTop(0,250);
      }
    });
  }
  
  public closeSubMenus(){
    if(this.settings.menu == "vertical"){
      this.menuService.closeAllSubMenus();
    }      
  }
}